module.exports = __webpack_public_path__ + "img/Battle_Pass_Icons_tickets.8bd5f978.png";